export const UPDATE_ADDRESS = 'UPDATE_ADDRESS'
export const EDIT_MODE = 'EDIT_MODE'
export const SELECT_ADDRESS = 'SELECT_ADDRESS'
export const DELETE_ADDRESS = 'DELETE_ADDRESS'
export const UPDATE_ALL_COUNTRIES = 'UPDATE_ALL_COUNTRIES'
export const LIST_MODE = 'LIST_MODE'
export const NEW_MODE = 'NEW_MODE'
export const UPDATE_STATES = 'UPDATE_STATES'
export const TOGGLE_LOADER = 'TOGGLE_LOADER'
export const SET_INITIAL_SELECTED_ADDRESS_ID = 'SET_INITIAL_SELECTED_ADDRESS_ID'
export const SET_SELECTED_ADDRESS_ID = 'SET_SELECTED_ADDRESS_ID'
export const RESET_ADDRESS = 'RESET_ADDRESS'
export const ON_TEXT_FIELD_CHANGE = 'ON_TEXT_FIELD_CHANGE'
export const ON_SELECT_CHANGE = 'ON_SELECT_CHANGE'
export const UPDATE_COUNTRY_CODE = 'UPDATE_COUNTRY_CODE'
export const SET_MERCHANT_COUNTRY = 'SET_MERCHANT_COUNTRY'
export const RESET_STATES = 'RESET_STATES'
export const VALIDATE_ALL_FIELDS = 'VALIDATE_ALL_FIELDS'
export const SHOW_ADDRESS_FEEDBACK = 'SHOW_ADDRESS_FEEDBACK'
export const HIDE_ADDRESS_FEEDBACK = 'HIDE_ADDRESS_FEEDBACK'
export const SHOW_DELETE_ADDRESS_MODAL = 'SHOW_DELETE_ADDRESS_MODAL'
export const HIDE_DELETE_ADDRESS_MODAL = 'HIDE_DELETE_ADDRESS_MODAL'
export const SHOW_DELETE_ADDRESS_ERROR = 'SHOW_DELETE_ADDRESS_ERROR'
export const CLEAR_DELETE_ADDRESS_ERROR = 'CLEAR_DELETE_ADDRESS_ERROR'
export const SHOW_ADD_ADDRESS_ERROR = 'SHOW_ADD_ADDRESS_ERROR'
export const CLEAR_ADD_ADDRESS_ERROR = 'CLEAR_ADD_ADDRESS_ERROR'
export const CLEAR_VALIDATION_ERROR_MESSAGES = 'CLEAR_VALIDATION_ERROR_MESSAGES'
